import { defineResolver } from 'customer-flows/utils/quote/resolvers'

export default {
  source: defineResolver<QuoteStrictSourceInput>(({ resolveStoreProp }) => ({
    resolve: () => {
      const channelId = resolveStoreProp('application', 'channelId')
      return {
        referralUrl: resolveStoreProp('application', 'referralUrl'),
        programConfigurationId: resolveStoreProp('program', 'safeId'),
        ...(channelId !== undefined && { isResellerWidget: false })
      }
    }
  }))
}
